import { all, fork } from 'redux-saga/effects'
import log from './log'
import booking from './booking'

export default function* parking() {
  yield all([fork(log), fork(booking)])
}
